/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-return-assign */
import React from 'react';
import ReactDOM from 'react-dom';
import { styled } from 'twin.macro';
import { WonderlineActivityType } from '../../../../player/types';
import hideModal, { showModal } from '../../../../styles/js/modals';

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  h1 {
    font-size: 22px;
    color: #7687c2;
    font-weight: 700;
    font-family: 'Arial Regular', Arial, sans-serif;
  }
`;

const ModalBody = styled.div`
  font-family: 'Arial Regular', Arial, sans-serif;
  margin-top: 30px;
  .line-header {
    font-size: 13px;
    color: #333333;
  }
  .line {
    font-family: 'Arial Bold', Arial, sans-serif;
    font-size: 24px;
    color: #363636;
    font-style: italic;
    font-weight: 700;
    margin-top: 8px;
  }
  .objective {
    font-weight: 700;
    font-size: 18px;
    color: #333333;
  }
`;

const ActivitiesData = [
  {
    icon: '/img/by-yourself.svg',
    title: 'By Yourself',
    type: WonderlineActivityType.BY_YOURSELF,
  },
  {
    icon: '/img/in-pairs.svg',
    title: 'In Pairs',
    type: WonderlineActivityType.IN_PAIRS,
  },
  {
    icon: '/img/small-group.svg',
    title: 'Small Group',
    type: WonderlineActivityType.SMALL_GROUP,
  },
  {
    icon: '/img/large-group.svg',
    title: 'Large Group',
    type: WonderlineActivityType.LARGE_GROUP,
  },
  {
    icon: '/img/wonder-wall.svg',
    title: 'Wonder Wall',
    type: WonderlineActivityType.WONDER_WALL,
  },
  {
    icon: '/img/take-home.svg',
    title: 'Take Home',
    type: WonderlineActivityType.TAKE_HOME,
  },
];

const ActivitiesDropdown = styled.div`
  width: 100%;
  padding: 20px;
  position: relative;
  top: -10px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  z-index: 1;
  position: relative;
  .activity {
    display: flex;
    align-items: center;
    gap: 28px;
    cursor: pointer;
    p {
      margin: 0;
      font-size: 17px;
      font-weight: 700;
      color: black;
    }
    img {
      width: 27px;
      height: 27px;
    }
  }
`;

const WonderActivitiesModal = ({ selectedWonderLine, setSelectedActivity }) => {
  const modalContent = (
    <div
      className="modal fade"
      id="wonder-activities-modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="wonder-activities-modal"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div
            className="custom__modal__content"
            style={{ borderRadius: '10px', border: '2px solid #7687c2' }}
          >
            <ModalHeader>
              <h1>Wonder Information</h1>
              <a href="" className="custom__modal__close" data-dismiss="modal">
                <img src="/img/plus-icon.svg" alt="" />
              </a>
            </ModalHeader>
            <ModalBody>
              <ActivitiesDropdown>
                {ActivitiesData.map((activity) => (
                  <button
                    key={activity.title}
                    className="activity"
                    onClick={() => {
                      if (selectedWonderLine) {
                        const activities =
                          selectedWonderLine.wonderLineActivities;
                        const foundActivity = activities.find(
                          (act) => act.type === activity.type
                        );
                        if (foundActivity) {
                          setSelectedActivity(foundActivity);
                          hideModal('wonder-activities-modal');
                          showModal('wonder-activity-modal');
                        }
                      }
                    }}
                  >
                    <img src={activity.icon} alt={activity.title} />{' '}
                    <p>{activity.title}</p>
                  </button>
                ))}
              </ActivitiesDropdown>
            </ModalBody>
          </div>
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined') return null;

  return ReactDOM.createPortal(modalContent, document.body);
};

export default WonderActivitiesModal;
